// extracted by mini-css-extract-plugin
export default {"link":"ResendVerificationEmailError_link__SX2ju"};